import styled from 'styled-components';

export default styled.button`
  padding: 0;
  border: none;
  font-family: AvenirNext;
  font-size: 24px;
  line-height: 1.375;
  text-transform: uppercase;
  color: #d6d6d6;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    color: #4d42f8;
  }
  &:focus {
    outline: none;
  }
`;
